import { Navigate, Outlet } from 'react-router-dom';
import {
  selectFeatureFlagsStatus,
  selectTrelloImportEnabled,
} from '~/slices/featureFlagsSlice';
import { useAppSelector } from '~/hooks/useAppSelector';

// Guards /admin/trello-import routes — only when TRELLO_IMPORT_ENABLED is true.
export default function TrelloImportRoute() {
  const trelloImportEnabled = useAppSelector(selectTrelloImportEnabled);
  const flagsStatus = useAppSelector(selectFeatureFlagsStatus);

  if (flagsStatus === 'idle' || flagsStatus === 'loading') return null;
  return trelloImportEnabled ? <Outlet /> : <Navigate to="/workspaces" replace />;
}
